import type { Guide } from '../types';

/**
 * S-21.10-20 — powód przekazania obsadzonego zlecenia do Trade opcjonalny (scenariusze e2e 12 i 18:
 * przekazanie z „Zmień stan”, przekazanie przed wyjazdem, zwrot z Trade z powodem z listy).
 */
export const guide: Guide = {
  flagKey: 'tradeHandoverReasonOptional',
  title: 'Powód przekazania obsadzonego zlecenia do Trade opcjonalny',
  whatItDoes:
    'Przy przekazaniu do Trade zlecenia obsadzonego pojazdem floty powód nie jest już wymagany — dotyczy Team Leadera i administracji („Zmień stan”) oraz planisty przed wyjazdem pojazdu na załadunek („Przekaż do Trade”). Powód z listy albo komentarz można dalej podać i wtedy trafia do historii zmian jak dotąd; bez powodu historia zapisuje samo przekazanie. Wniosek o przekazanie po wyjeździe pojazdu i zwrot zlecenia z Trade do FTL wymagają powodu bez zmian.',
  audience: ['planista FTL', 'Team Leader (planista główny)', 'administrator', 'Trade'],
  presentationItems: ['S-21.10-20'],
  steps: [
    {
      route: '/user-offers/:orderId/show',
      record: {
        description: 'zlecenie obsadzone Twoim pojazdem, przed wyjazdem na załadunek',
        listPath: '/user-offers',
        listFilter: { forklift: 'hide', dzial: 'FTL' },
      },
      target: 'trade-transfer-self',
      title: 'Planista przed wyjazdem — bez powodu',
      description:
        'Dopóki pojazd nie wyruszył na załadunek, „Przekaż do Trade” jest aktywne także przy „— bez powodu —”. Historia zapisze wtedy samo przekazanie przed wyjazdem z szacunkiem wyjazdu.',
      action: 'Wybierz powód z listy albo zostaw „— bez powodu —” i kliknij „Przekaż do Trade”.',
      recorder: { account: 'ftl2', demo: { kind: 'order', number: 'DEMO/2026/10/W01' } },
    },
    {
      route: '/user-offers/:orderId/show',
      record: {
        description: 'zlecenie obsadzone pojazdem floty',
        listPath: '/user-offers',
        listFilter: { forklift: 'hide', planningStatus: 'assigned' },
      },
      target: 'transfer-reason',
      title: 'Team Leader i administracja — „Zmień stan”',
      description:
        'Po wyborze stanu „Przekazane do Trade” pole „Powód przekazania do Trade” nie jest już wymagane, a „Zmień” działa bez powodu. Podany powód — z listy albo komentarzem — trafia do historii zmian jak dotąd.',
      action: 'W „Zmień stan” wybierz „Przekazane do Trade”, opcjonalnie powód, i kliknij „Zmień”.',
      recorder: {
        account: 'master',
        demo: { kind: 'order', number: 'DEMO/2026/10/H03' },
        actions: [{ kind: 'select', label: 'Zmień stan', option: 'Przekazane do Trade' }],
      },
    },
    {
      route: '/user-offers/:orderId/show',
      record: {
        description: 'zlecenie w Trade',
        listPath: '/user-offers',
        listFilter: { forklift: 'hide', dzial: 'TRADE' },
      },
      target: 'transfer-reason',
      title: 'Zwrot do FTL — powód dalej wymagany',
      description:
        'Zwrot z Trade do FTL się nie zmienia: „Powód zwrotu do FTL (wymagany)”, a bez powodu z listy „Zmień” jest nieaktywne. Tak samo wniosek o przekazanie po wyjeździe pojazdu — czyta go przełożony, więc powód zostaje obowiązkowy.',
      action: 'Przy zwrocie wybierz powód z listy i, jeśli trzeba, dopisz komentarz.',
      recorder: {
        account: 'trade',
        demo: { kind: 'order', number: 'DEMO/2026/10/T02' },
        actions: [{ kind: 'select', label: 'Zmień stan', option: 'Gotowe do planowania' }],
      },
    },
  ],
};
